(function () {
  'use strict';

  angular
  .module('service.load', [])

  /* @ngInject */
  .factory('LoadService', ["$interval", "$window", "$injector", "$q", function ($interval, $window, $injector, $q) {
    var files = [],
      services = [];

    var service = {
      load: load,
      getService: getService
    };
    return service;

    ////////////

    function load(type, name, path) {
      var deferred = $q.defer(),
        element,
        loaded;

      if (files.indexOf(name) !== -1) {
        deferred.resolve();
      } else {
        switch (type) {
          case 'css':
            element = $window.document.createElement('link');
            element.type = 'text/css';
            element.rel = 'stylesheet';
            element.href = path;
            break;
          case 'js':
            element = $window.document.createElement('script');
            element.src = path;
            break;
        }
        /* eslint-disable */
        element.onload = element['onreadystatechange'] = function () {
          if ((element['readyState'] && !/^c|loade/.test(element['readyState'])) || loaded) return;
          element.onload = element['onreadystatechange'] = null;
          loaded = true;
          files.push(name);
          if (type === 'js') {
            $injector.loadNewModules([name]);
          }
          deferred.resolve();
        };
        /* eslint-enable */
        element.onerror = function () {
          deferred.reject(new Error('Unable to load ' + path));
        };

        var insertBeforeElem = $window.document.getElementsByTagName('head')[0].lastChild;
        insertBeforeElem.parentNode.insertBefore(element, insertBeforeElem.nextSibling);

        /*
         The event load or readystatechange doesn't fire in:
         - PhantomJS 1.9 (headless webkit browser)
         - iOS < 6       (default mobile browser)
         - Android < 4.4 (default mobile browser)
         - Safari < 6    (desktop browser)
         */
        if (type === 'css') {
          var useCssLoadPatch = false,
            ua = $window.navigator.userAgent.toLowerCase();

          if (ua.indexOf('phantomjs/1.9') > -1) {
            // PhantomJS ~1.9
            useCssLoadPatch = true;
          } else if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
            // iOS < 6
            var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
            var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
            useCssLoadPatch = iOSVersion < 6;
          } else if (ua.indexOf('android') > -1) {
            // Android < 4.4
            var androidVersion = parseFloat(ua.slice(ua.indexOf('android') + 8));
            useCssLoadPatch = androidVersion < 4.4;
          } else if (ua.indexOf('safari') > -1) {
            // Safari < 6
            var versionMatch = ua.match(/version\/([\.\d]+)/i);
            useCssLoadPatch = (versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6);
          }

          if (useCssLoadPatch) {
            var tries = 1000; // * 20 = 20000 miliseconds
            var interval = $interval(function () {
              try {
                element.sheet.cssRules;
                $interval.cancel(interval);
                element.onload();
              } catch (e) {
                if (--tries <= 0) {
                  element.onerror();
                }
              }
            }, 20);
          }
        }
      }
      return deferred.promise;
    }

    function getService(name, data, callback) {
      if ($injector.has(name)) {
        callbackService(name, data, callback);
      } else {
        services.push({ name: name, data: data, callback: callback });
        if (_.filter(services, { data: { ctrl: { js: data.ctrl.js } } }).length === 1) {
          var strKebabCase = _.kebabCase(name),
            strPointCase = strKebabCase.replace(/-/g, '.');
          service.load('js', strPointCase, data.ctrl.js ? data.ctrl.js : '/js/' + strKebabCase + '.js')
            .then(function () {
              _.each(_.filter(services, { data: { ctrl: { js: data.ctrl.js } } }), function (item) {
                callbackService(item.name, item.data, item.callback);
              });
              _.remove(services, { data: { ctrl: { js: data.ctrl.js } } });
            })
            .catch(function (error) {
              throw error;
            });
        }
      }
    }

    function callbackService(name, data, callback) {
      var _service = $injector.get(name);
      if (angular.isFunction(_service[callback])) {
        _service[callback](data.ctrl, data.scope, data.element);
      }
    }
  }]);

})();
